import { faChevronDown, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  data () {
    return {
      dataSelectSmsTemplateValue: null,
      dataSelectOptionsSmsTemplate: [],
      dataIconDown: faChevronDown,
      dataComponentDeselect: {
        render: createElement => createElement(FontAwesomeIcon, {
          props: {
            icon: faTimes
          }
        })
      }
    };
  }
};
